import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFingerprint = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 12.75c0 2.75 2 5.5 5 5.5 1 0 2 0 3.25-.75m-9 .75C7.5 16 7 14.5 7.25 12.75S8.75 10 10 10c1.5 0 2.75 1 2.75 2.75 0 1.25 1.25 2.5 2.75 2.5 2.5 0 2.75-2 2.75-3.75 0-2.5-1.75-7-8.25-7-3.5 0-8.25 2.5-8.25 8.75m15.5-9C16 3 13.75 1.75 10 1.75c-4.75 0-7 2.25-8.25 3.5m13.75 7s0-5-5.5-5c-3.25 0-5.135 2.75-5.37 5-.13 1.25 0 2.75.62 4"
	})]
});
const ForwardRef = forwardRef(SvgFingerprint);
export { ForwardRef as ReactComponent };
